import React, { Children } from 'react';
import { motion } from 'framer-motion';
export function QualityRing({
  score,
  size = 48
}: {
  score: number;
  size?: number;
}) {
  const radius = (size - 8) / 2;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference - score / 100 * circumference;
  const color = score >= 80 ? 'text-emerald-500' : score >= 60 ? 'text-amber-500' : 'text-red-500';
  return <div className="relative flex items-center justify-center" style={{
    width: size,
    height: size
  }} data-id="element-6844" data-mp="20piis7tngpkh">
      
      <svg className="transform -rotate-90" style={{
      width: size,
      height: size
    }} data-id="element-6845" data-mp="25mio2giodoaj">
        
        <circle cx={size / 2} cy={size / 2} r={radius} stroke="currentColor" strokeWidth="6" fill="transparent" className="text-gray-100" data-id="element-6846" data-mp="2af22tgt3mpgx" />
        
        <motion.circle cx={size / 2} cy={size / 2} r={radius} stroke="currentColor" strokeWidth="6" fill="transparent" strokeDasharray={circumference} initial={{
        strokeDashoffset: circumference
      }} animate={{
        strokeDashoffset
      }} transition={{
        duration: 1.2,
        ease: 'easeOut'
      }} className={color} strokeLinecap="round" data-id="element-6847" data-mp="2kczqo371qk90" />
        
      </svg>
      <span className="absolute text-sm font-bold text-gray-900" data-id="element-6848" data-mp="319ne441nuh71">{score}%</span>
    </div>;
}
export function ProgressBar({
  value,
  color = 'bg-blue-500',
  label
}: {
  value: number;
  color?: string;
  label?: string;
}) {
  return <div data-id="element-6849" data-mp="3tykl3b0f8rkh">
      {label && <div className="flex justify-between text-xs mb-1" data-id="element-6850" data-mp="3txrj0nceqq8o">
          <span className="text-gray-600" data-id="element-6851" data-mp="3oyodz2wfgk0p">{label}</span>
          <span className="font-medium text-gray-700" data-id="element-6852" data-mp="3p1aw1wgy2hx6">{value}%</span>
        </div>}
      <div className="h-1.5 bg-gray-100 rounded-full overflow-hidden" data-id="element-6853" data-mp="3k6wvlfnfdkln">
        <motion.div initial={{
        width: 0
      }} animate={{
        width: `${value}%`
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className={`h-full rounded-full ${color}`} data-id="element-6854" data-mp="3fa6fisbmep08" />
        
      </div>
    </div>;
}